module.exports = __webpack_public_path__ + "static/author-enbw-img-bb970570392180cd09634b0a3a116858.png";